import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser';

// Validate required environment variables
const clientId = process.env.REACT_APP_AZURE_CLIENT_ID;
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID;

if (!clientId) {
  throw new Error('REACT_APP_AZURE_CLIENT_ID is required in environment variables');
}

if (!tenantId) {
  throw new Error('REACT_APP_AZURE_TENANT_ID is required in environment variables');
}

// MSAL configuration for Single-Page Application with MS365 context support
const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: process.env.REACT_APP_AZURE_AUTHORITY || `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: false, // Set to false for SPA
  },
  
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        // Suppress interaction_in_progress errors
        if (message && (message.includes('interaction_in_progress') || message.includes('Interaction is currently in progress'))) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
        }
      },
    },
  },
};

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

console.log('[MSAL] Configuration loaded:', {
  clientId: msalConfig.auth.clientId,
  authority: msalConfig.auth.authority,
  redirectUri: msalConfig.auth.redirectUri,
});

// Login request configuration - Graph scope for user info
export const loginRequest = {
  scopes: [
    'https://graph.microsoft.com/User.Read'
  ],
};

// Microsoft 365 Copilot Chat API - all of these delegated scopes are required by the API
export const copilotTokenRequest = {
  scopes: [
    'https://graph.microsoft.com/Sites.Read.All',
    'https://graph.microsoft.com/Mail.Read',
    'https://graph.microsoft.com/People.Read.All',
    'https://graph.microsoft.com/OnlineMeetingTranscript.Read.All',
    'https://graph.microsoft.com/Chat.Read',
    'https://graph.microsoft.com/ChannelMessage.Read.All',
    'https://graph.microsoft.com/ExternalItem.Read.All',
  ],
};

// SharePoint-specific token request
export const sharePointTokenRequest = {
  scopes: [
    'https://igniagroup.sharepoint.com/Sites.Read.All'
  ],
};

// SharePoint silent request
export const sharePointSilentRequest = {
  scopes: sharePointTokenRequest.scopes,
  account: undefined as any,
};